import React from 'react';
import HeadingDescription from '../HeadingDescription';
import TechnicalDataTable from '../TechnicalDataTable';
import ProposalImage from '../ProposalImage';
import { getTableData } from './utils';
import conveyorImg from '../../assets/proposalImages/overhead_convevors_2_cropped.png';

export default function ConveyorSection({ conveyorSpec, uploadedImage }) {
  if (!conveyorSpec) return null;

  return (
    <div className="a4-paddings quotation-page quotation-page-compact">
      <div className="quotation-page-inner quotation-bg-light">
        <div className="quotation-section-block">
          <HeadingDescription heading="Over Head Conveyor" description="" level={2} />
          <ProposalImage src={uploadedImage || conveyorImg} wrapperStyle={{ marginBottom: 12 }} imgStyle={uploadedImage ? { maxHeight: 500, width: 'auto', objectFit: 'contain' } : {}} />
          <TechnicalDataTable data={getTableData(conveyorSpec)} title={conveyorSpec?.label || 'Technical Specification'} />
        </div>
      </div>
    </div>
  );
}
